module.exports = new __parcel__URL__("welcome-to-project-pages-spork-rebranding.e36e44bb.png").toString();